export default "__VITE_ASSET__DUeIlaRh__"